import {
  ButtonProps,
} from 'spindl-shared-components';
import { LogoWithHeaderProps } from '../../molecules/LogoWithHeader';

type InformationBlockInternalProps = {
  logoWithHeader?: LogoWithHeaderProps;
  signUpButton?: ButtonProps;
};

type InformationBlockPropsValues = {
  '': InformationBlockInternalProps;
};

const propValues: InformationBlockPropsValues = {
  '': {
    logoWithHeader: {
      type: 'TitleWithDescription',
    },
    signUpButton: { // FIXME: rename
      type: 'Text',
      size: 'Large',
      styleType: 'Primary',
      state: 'Default',
    },
  },
};

const getProps = (type: string): InformationBlockInternalProps => {
  const values: InformationBlockInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
